export default {
  guide_last_step:'上一步',
  guide_next_step:'下一步',
  guide_more_step:'更多',

 guide_overview_daily_step1_title:'核心功能1',
 guide_overview_daily_step1_subtitle:'查看当前游戏每日运营数据与关联事件',
 guide_overview_daily_step1_description:'点击核心指标趋势坐标轴，查看当天对应事件分析。',

 guide_overview_daily_step2_title:'核心功能1',
 guide_overview_daily_step2_subtitle:'查看当前游戏每日运营总况的分维度数据',
 guide_overview_daily_step2_description:'选择维度，查看分国家维度指标数据。',

 guide_overview_daily_step3_title:'核心功能1',
 guide_overview_daily_step3_subtitle:'查看当前游戏每日运营总况的关注指标与统计数据',
 guide_overview_daily_step3_description:'点击设置，可调整表格指标展示顺序或查看更多统计数据。',

 guide_realtime_user_step1_title: '核心功能2',
 guide_realtime_user_step1_subtitle: '查看全球游戏用户的实时数据',
 guide_realtime_user_step1_description: '在实时用户页面选择不同的对比日期，查看两个对比日期的实时数据。',

 guide_realtime_user_step2_title: '核心功能2',
 guide_realtime_user_step2_subtitle: '查看游戏用户的分国家/分区服实时数据',
 guide_realtime_user_step2_description: '下拉筛选查看分国家/分区域/分区服的图表展开实时数据。',

 guide_realtime_user_step3_title: '核心功能2',
 guide_realtime_user_step3_subtitle: '查看各国用户实时指标异动情况',
 guide_realtime_user_step3_description: '下拉筛选查看与全球趋势相同或相反的指标实时异动情况。',

 guide_country_comparison_step1_title: '核心功能3',
 guide_country_comparison_step1_subtitle: '查看全球多时区数据，分国家进行数据对比',
 guide_country_comparison_step1_description: '选择两个或多个国家，分析对比不同国家的数据。',

 guide_country_comparison_step2_title: '核心功能3',
 guide_country_comparison_step2_subtitle: '查看当地时区数据',
 guide_country_comparison_step2_description: '选择某个国家查看当地时区数据。',

 guide_tableau_step1_title: '核心功能4',
 guide_tableau_step1_subtitle: '查看游戏定制化特性报表',
 guide_tableau_step1_description: '点击特性报表菜单下任意一张特性报表进入页面，可查看游戏玩法/关卡/活动等特性数据并下载分析。',

 guide_subscribe_step1_title: '核心功能5',
 guide_subscribe_step1_subtitle: '报表订阅推送',
 guide_subscribe_step1_description: '点击报表更多操作，选择“订阅”进入订阅设置。',

 guide_subscribe_step2_title: '核心功能5',
 guide_subscribe_step2_subtitle: '报表订阅推送',
 guide_subscribe_step2_description: '在“订阅设置”页面，可配置报表每日/每周/每月例行化推送，如需退订，可在“订阅管理”页面操作。',
}
